<template>
  <Preparing v-if="isPreparing" />

  <div v-if="!isPreparing" class="container-fluid">
    <div class="dashboard-heading mb-5">
      <h2 class="fs-22 font-weight-semi-bold">درخواست پشتیبانی</h2>
    </div>
    <ul class="nav nav-tabs generic-tab pb-30px" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" id="mine-tab" data-toggle="tab" href="#mine" role="tab" aria-controls="mine"
          aria-selected="false">
          تیکت های من
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link p-0" id="new-tab" data-toggle="tab" href="#new" role="tab" aria-controls="new"
          aria-selected="true">
          <button type="button" class="btn theme-btn theme-btn-new-ticket">
            <i class="la la-plus"></i> تیکت جدید
          </button>
        </a>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane" id="new" role="tabpanel" aria-labelledby="new-tab">
        <form class="col-lg-12" method="POST" enctype="multipart/form-data" v-on:submit="sendTicket">
          <div class="card card-item">
            <div class="card-body">
              <div class="form-row">
                <div class="col-lg-6 form-group">
                  <label class="label-text">موضوع تیکت</label>
                  <Dropdown :loading="false" class="form-control form-control-new-ticket primCom" v-model="primaryTopic"
                    :options="primaryTicketOptions" optionLabel="name" optionValue="name"
                    placeholder="موضوع تیکت را انتخاب کنید" />
                </div>
                <div v-if="primaryTopic === 'محصول'" class="col-lg-6 form-group">
                  <label class="label-text">عنوان تیکت</label>
                  <Dropdown :loading="false" class="form-control form-control-new-ticket primCom" v-model="newSentTopic"
                    :options="ticketOptions" optionLabel="PaperServiceTypeName" placeholder="عنوان تیکت را انتخاب کنید" />
                </div>
                <div v-if="primaryTopic === 'سایر'" class="col-lg-6 form-group">
                  <label class="label-text">عنوان تیکت</label>
                  <input onfocus="this.removeAttribute('readonly');" readonly v-model="otherTitle" class="
                    form-control
                    form-control-register

                    pl-3
                  " type="text" placeholder="عنوان تیکت را وارد کنید" />
                </div>

                <div class="col-lg-12 form-group">
                  <textarea required v-model="newSentContent" class="col-lg-12 form-control-new-ticket"
                    placeholder="پیام خود را اینجا بنویسید..." rows="4"></textarea>
                </div>
                <div class="col-lg-6 form-group">
                  <div class="file-upload-wrap">
                    <input onfocus="this.removeAttribute('readonly');" readonly v-on:keyup.enter="sendTicket()"
                      ref="inputFile" accept="application/pdf,application/vnd.ms-excel,.docx,.doc,image/*" type="file"
                      v-on:change="handleFileUpload($event)" class="file-upload-input" />
                    <span class="file-upload-text"><i class="la la-cloud-upload mr-2 fs-18"></i>فایل تیکت</span>
                  </div>
                </div>
                <div class="col-lg-12 form-group d-flex align-items-center justify-content-start">
                  <button :disabled="working" type="submit" class="btn theme-btn theme-btn-new-ticket">
                    ارسال تیکت
                    <div style="transform: rotateY(180deg)" v-if="!working"></div>
                    <div v-if="working" class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </button>
                </div>
              </div>
              <div class="progresaa">
                <div class="bg-info" :style="calcProgress()" style="height: 2px" role="progressbar"></div>
              </div>
            </div>
          </div>
        </form>
        <!-- end message-inbox-item -->
        <!-- message-sidebar -->

        <!-- message-content -->
      </div>
      <div class="tab-pane active" id="mine" role="tabpanel" aria-labelledby="mine-tab">
        <NoContent @itemClicked="activeTab = 'new-ticket'" image="images/faq-null-icon.png" linkTitle="ارسال تیکت"
          link="/ticket" title="پیامی برای نمایش وجود ندارد"
          disc="شما تا کنون پیامی برای پشتیبانی ارسال نکرده اید، جهت ارسال پیام برروی دکمه تیکیت جدید کلیک کنید."
          v-if="mySearchedtickets.length === 0" />
        <div v-if="mySearchedtickets.length !== 0" class="dashbosard-message-wrapper d-flex my-4">
          <div class="message-sidebar">
            <div class="d-flex justify-content-start">
              <form action="#" class="col-lg-4 p-4">
                <div class="form-group mb-0">
                  <input onfocus="this.removeAttribute('readonly');" readonly v-model="searchInMyTickets"
                    class="form-control form--control form-control-ticket form--control-gray pl-3" type="text"
                    placeholder="جستجو کنید" />
                  <button type="button" class="search-icon">
                    <i @click="searchInMyTickets = ''" :class="ifSearching()"></i>
                  </button>
                </div>
              </form>
            </div>
            <div class="divider"></div>

            <div class="message-inbox-item border-bottom border-bottom-gray">
              <div class="notification-body">
                <a v-for="tck in mySearchedtickets" :key="tck.Id" @click="goToDetail(tck)"
                  class="media media-card align-items-center crToPoi" :style="ifLastItem(tck)"
                  :class="ifTicketIsActive(tck)">
                  <div class="media-body overflow-hidden">
                    <div class="d-flex justify-content-between">
                      <h5 class="fs-14">{{ tck.Title }}</h5>
                      <h6 class="fs-12">
                        <button type="button" class="btn fs-14 theme-btn-ticket" :style="statusColor(tck)">
                          {{ calcTicketStatus(tck) }}
                        </button>
                      </h6>
                    </div>
                    <p class="text-truncate lh-18 pt-1 text-gray fs-13">
                      موضوع : پروژه ی {{ tck.ProductName }}
                    </p>
                    <span class="fs-12 d-block lh-18 pt-1 text-gray">{{
                      parseDates(tck.Date)
                    }}</span>
                  </div>
                </a>
              </div>
            </div>
            <!-- end message-inbox-item -->
          </div>
          <!-- message-sidebar -->

          <!-- message-content -->
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import Preparing from "../components/Preparing.vue";
import NoContent from "../components/NoContent.vue";

import {
  donePapersFilters,
  articleFilters,
  ticketClientStatuses,
  primaryTicketOptions
} from "../constants";
import axios from "axios";
import router from "../router/index";
import ls from "localstorage-slim";
import { DOMAIN } from "../configs";
import CkEditor from "../components/CkEditor.vue";
import { FilterMatchMode } from "primevue/api";
export default {
  name: "Ticket",
  components: {
    Preparing,
    NoContent
  },
  data() {
    return {
      otherTitle: '',
      primaryTicketOptions: primaryTicketOptions,
      ticketOptions: [],
      newSentTopic: "",
      newSentContent: "",
      newSentFile: "",
      ticketClientStatuses: ticketClientStatuses,
      isPreparing: true,
      tickets: [],
      mytickets: [],
      primaryTopic: "",
      searchInMyTickets: "",
      mySearchedtickets: [],
      me: {},
      working: false,
      uploadTicketProgress: 0,
    };
  },
  watch: {
    searchInMyTickets() {
      this.mySearchedtickets = this.mytickets.filter(
        (t) =>
          t.Title.includes(this.searchInMyTickets) ||
          t.ProductName.includes(this.searchInMyTickets)
      );
    },
  },
  methods: {
    ifLastItem(t) {
      if (this.mySearchedtickets.indexOf(t) === this.mySearchedtickets.length - 1) {
        return ' border-bottom-right-radius: 25px !important;border-bottom-left-radius: 25px !important';
      }
    },
    statusColor(t) {
      switch (parseInt(t.Status)) {
        case 0:
          return "background-color:#358ff7;color:white;";
        case 1:
          return "background-color:#f2ca16;color:white;";
        case 2:
          return "background-color:#1cc219;color:white;";
        case 3:
          return "background-color:#4abaff;color:white;";
        case 4:
          return "background-color:#707070;color:black;";
        case 5:
          return "background-color:white;color:red;";

        default:
          break;
      }
    },
    ifSearching() {
      if (this.searchInMyTickets !== "") {
        return "la la-close";
      } else {
        return "la la-search";
      }
    },
    calcProgress() {
      var res = this.uploadTicketProgress;
      var ress = `width:${res}%;`;
      return ress;
    },
    calcTicketStatus(t) {
      let st = t.Status;
      return this.ticketClientStatuses.find((s) => s.code === st).name;
    },
    ifTicketIsActive(t) {
      if (t.Status === 0) {
        return "message-active";
      } else {
        return "";
      }
    },
    goToDetail(tck) {
      ls.set("viewingTicket", tck);
      ls.set("viewingTicketId", tck.Id);

      router.push({
        name: "TicketDetail",
      });
    },
    async getMyTickets() {
      await axios
        .post("/api/v1/teacher/ticket", {
          mobile: this.me.Mobile,
        })
        .then((response) => {
          if (response.status === 200) {
            this.mytickets = response.data;
            this.mySearchedtickets = response.data.reverse();
          }
        });
    },
    async getTicketTopics() {
      await axios
        .post("/api/v1/teacher/paper/mypaper", {
          uidteach: this.me.Uid,
        })
        .then((response) => {
          if (response.status === 200) {
            this.ticketOptions = response.data;
          }
        });
    },
    async sendTicket(e) {
      e.preventDefault();
      if (this.primaryTopic === "محصول" && this.ticketOptions.length === 0) {
        this.$toast.add({
          severity: "error",
          summary: "لطفا موضوع تیکت را درست انتخاب کنید",
          life: 5000,
        });
        return;
      }
      if (this.primaryTopic === "سایر" && this.otherTitle === '') {
        this.$toast.add({
          severity: "error",
          summary: "لطفا عنوان تیکت را انتخاب کنید",
          life: 5000,
        });
        return;
      }
      this.working = true;

      let formData = new FormData();
      if (this.otherTitle !== '') {
        this.primaryTopic = this.otherTitle
      }
      formData.append("File", this.newSentFile[0]);
      formData.append("title", this.primaryTopic);
      formData.append(
        "paperid",
        this.newSentTopic.Id === undefined ? 0 : this.newSentTopic.Id
      );
      formData.append(
        "productname",
        this.newSentTopic.PaperServiceTypeName === undefined
          ? "محصول"
          : this.newSentTopic.PaperServiceTypeName
      );
      formData.append("type", 0);
      formData.append("mobile", this.me.Mobile);
      formData.append("name", this.me.Name);
      formData.append("dpid", 0);
      formData.append("content", this.newSentContent);
      await axios
        .post("/api/v1/teacher/ticket/send", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadTicketProgress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          if (response.status === 200 && response.data.data === "ok") {
            this.$toast.add({
              severity: "success",
              summary: "تیکت با موفقیت ارسال شد",
              life: 5000,
            });
            this.$refs.inputFile.value = null;
            this.newSentContent = "";
            this.primaryTopic = "";
            this.newSentTopic = "";

            this.uploadTicketProgress = 0;
            this.getMyTickets();
            this.working = false;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "لطفا خطاها را برطرف کنید یا مجدد تلاش کنید",
              life: 5000,
            });
            this.working = false;
          }
        });
    },
    handleFileUpload(event) {
      if (event.target.files[0].size > 10000000) {
        this.$toast.add({
          severity: "error",
          summary: "خطا در ثبت پروژه",
          detail: "حداکثر حجم فایل قابل قبول 10 مگابایت است",
          life: 5000,
        });
        return;
      }
      this.newSentFile = event.target.files;
    },
  },
  async beforeMount() {
    this.me = JSON.parse(ls.get("user"));
    await this.getMyTickets();
    await this.getTicketTopics();
    this.isPreparing = false;
  },
};
</script>

<style></style>
